export { nb } from '@payloadcms/translations/languages/nb'
